import { Divider, Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const StoreConfigurationSkeleton = () => {
  return (
    <Styles.MainContainer>
      <Styles.Section>
        <Skeleton variant="text" width={200} height={20} />
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.Section>

      <Styles.Section>
        <Skeleton variant="text" width={180} height={28} />
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.Section>

      <Divider />

      <Styles.Section>
        <Skeleton variant="text" width={180} height={28} />
        <Skeleton variant="text" width="100%" height={20} />
        <Skeleton variant="text" width="80%" height={20} />
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.Section>

      <Divider />

      <Styles.Section>
        <Skeleton variant="text" width={220} height={28} />
        <Skeleton variant="text" width="100%" height={20} />
        <Skeleton variant="text" width="80%" height={20} />
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.Section>

      <Divider />

      <Styles.Section>
        <Skeleton variant="text" width={120} height={28} />
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.Section>
    </Styles.MainContainer>
  )
}

export default StoreConfigurationSkeleton
